module.exports = __webpack_public_path__ + "img/oli-2.450bd435.png";